var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.3645 11.6355 0 7.5 0ZM7.5 3.075C7.69284 3.075 7.88134 3.13218 8.04168 3.23932C8.20202 3.34645 8.32699 3.49873 8.40078 3.67688C8.47458 3.85504 8.49389 4.05108 8.45627 4.24021C8.41865 4.42934 8.32579 4.60307 8.18943 4.73943C8.05307 4.87579 7.87935 4.96865 7.69021 5.00627C7.50108 5.04389 7.30504 5.02458 7.12688 4.95078C6.94873 4.87699 6.79645 4.75202 6.68932 4.59168C6.58218 4.43134 6.525 4.24284 6.525 4.05C6.525 3.79141 6.62772 3.54342 6.81057 3.36057C6.99342 3.17772 7.24141 3.075 7.5 3.075ZM9.9 11.55H5.4V10.35H7.05V7.05H5.85V5.85H8.25V10.35H9.9V11.55Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.22df51ddbc8654a4490c48d5fbb7702a.svg";
export { ForwardRef as ReactComponent };